import * as React from 'react';
import { Select } from 'antd';
import GetProductTagsQuery from '../../Query/ProductTags';
import GetExternalBlogTagsQuery from '../../Query/ExternalBlog';

interface IExternalBlogTagSelectProps {
    name: string;
    tags: string[];
    onChange: (key: string, val: any, ...args: any[]) =>  void;
}

export class ExternalBlogTagSelect extends React.Component<IExternalBlogTagSelectProps> {
    render() {
        const { name, tags, onChange } =  this.props;
        return (
            <GetExternalBlogTagsQuery>
                {({externalBlogTags}) => (<Select
                    mode="tags"
                    defaultValue={tags}
                    style={{ width: '100%' }}
                    placeholder="Type tags"
                    onChange={(tags: string[]) => onChange(name, tags, false)}
                >
                    {externalBlogTags && externalBlogTags.externalBlogTags &&
                    externalBlogTags.externalBlogTags.map((t: string) => (
                        <Select.Option key={t} value={t} style={{ position: 'relative', backgroundColor: /* t.color ||*/ 'transparent'/*, color: '#FFF'*/ }}>
                        <span style={{ zIndex: 2, position: 'relative'/*, color: '#FFF'*/, fontSize: '90%', fontWeight: 500 }}>{t}</span>
                        <span style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: /*t.color || */ 'transparent'/*, color: '#FFF'*/ }} />
                        </Select.Option>
                    ))}
                </Select>)
                }
            </GetExternalBlogTagsQuery>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Others/ExternalBlogTagSelect/ExternalBlogTagSelect.tsx